import React from 'react'
import './Button.scss'

const Button = ({ color, text, disabled = false, onClick }) => {
  return (
    <button
      style={{ backgroundColor: color }}
      className={`veyetals-button veyetals-button--${color}`}
      onClick={onClick}
      disabled={disabled}
    >
      <span className='veyetals-button__text'>{text}</span>
    </button>
  )
}

export default Button
